"use client";

import { usePathname } from "next/navigation";

/**
 * Sayfa içeriğini sarar; her adres (pathname) değişiminde `key` değişerek
 * içerik yeniden bağlanır ve kısa giriş animasyonu (.sayfa-gir) yeniden oynar.
 * Böylece kullanıcı bir sayfadan diğerine geçtiğini net biçimde hisseder.
 */
export function SayfaGecis({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  return (
    <div key={pathname} className="sayfa-gir">
      {children}
    </div>
  );
}
